import { useEffect, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

// Firmaets kunderegister, sortert på navn. Lesetilgang krever admin eller dispatcher.
export function useCarrierCustomers(orgId) {
  const [state, setState] = useState({ customers: [], loading: Boolean(orgId) });

  useEffect(() => {
    if (!orgId) {
      setState({ customers: [], loading: false });
      return undefined;
    }
    return onSnapshot(
      collection(db, 'organizations', orgId, 'customers'),
      snap => setState({
        customers: snap.docs.map(d => ({ id: d.id, ...d.data() })).sort((a, b) => String(a.name ?? '').localeCompare(String(b.name ?? ''))),
        loading: false,
      }),
      () => setState({ customers: [], loading: false }),
    );
  }, [orgId]);

  return state;
}
